module.exports = require('./config.prod.json')



// WEBPACK FOOTER //
// ./src/assets/config.prod.js